import { Routes, Route, Navigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Layout from './components/layout/Layout'
import { SidebarProvider } from './context/SidebarContext'

// Getting Started
import Overview from './components/pages/getting-started/Overview'
import Authentication from './components/pages/getting-started/Authentication'
import QuickStart from './components/pages/getting-started/QuickStart'

// Integration Guides
import ParcelCreation from './components/pages/guides/ParcelCreation'
import LabelGeneration from './components/pages/guides/LabelGeneration'
import ParcelTracking from './components/pages/guides/ParcelTracking'
import Payments from './components/pages/guides/Payments'

// Widgets
import ApmFinderWidget from './components/pages/widgets/ApmFinderWidget'

// API Reference
import ApiReference from './components/pages/api-reference/ApiReference'
import ApiDocs from './components/pages/api-reference/ApiDocs'

// Testing & Support
import SandboxEnvironment from './components/pages/testing/SandboxEnvironment'
import Support from './components/pages/support/Support'

function App() {
  return (
    <SidebarProvider>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Routes>
        <Route path="/" element={<Layout />}>
          {/* Default redirect */}
          <Route index element={<Navigate to="/getting-started/overview" replace />} />

          {/* Getting Started */}
          <Route path="getting-started">
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<Overview />} />
            <Route path="authentication" element={<Authentication />} />
            <Route path="quick-start" element={<QuickStart />} />
          </Route>

          {/* Integration Guides */}
          <Route path="guides">
            <Route index element={<Navigate to="parcel-creation" replace />} />
            <Route path="parcel-creation" element={<ParcelCreation />} />
            <Route path="label-generation" element={<LabelGeneration />} />
            <Route path="parcel-tracking" element={<ParcelTracking />} />
            <Route path="payments" element={<Payments />} />
          </Route>

          {/* Widgets */}
          <Route path="widgets">
            <Route index element={<Navigate to="apm-finder" replace />} />
            <Route path="apm-finder" element={<ApmFinderWidget />} />
          </Route>

          {/* API Reference */}
          <Route path="api-reference" element={<ApiReference />}>
            <Route index element={<Navigate to="parcel-api" replace />} />
            <Route path="parcel-api" element={<ApiDocs specUrl="/specs/parcel-api.yaml" />} />
            <Route path="label-api" element={<ApiDocs specUrl="/specs/label-api.yaml" />} />
            <Route path="status-api" element={<ApiDocs specUrl="/specs/status-api.yaml" />} />
          </Route>

          {/* Testing */}
          <Route path="testing">
            <Route index element={<Navigate to="sandbox" replace />} />
            <Route path="sandbox" element={<SandboxEnvironment />} />
          </Route>

          {/* Support */}
          <Route path="support" element={<Support />} />
        </Route>
      </Routes>
      </Box>
    </SidebarProvider>
  )
}

export default App
